import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { decryptAES } from '../../../utils/Encryption';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { productColdefs, PurchaseOrderPopup } from './PurchaseOrderTable';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import moment from 'moment';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import { de } from 'date-fns/locale';
import { SelectItemListPopUp } from '../../../components/dropdown/SelectItemListPopUp';
import CommonServices from '../../../services/axiosServices/apiServices/CommonServices';
import { saveAs } from "file-saver";
import { permission } from '../../../utils/enums/ValidationMessage';

export default class PurchaseOrder extends Component {

    constructor(props) {
        super(props)
        //this.masterEntryServices = new MasterEntryServices();
        this.transactionStockServices = new TransactionStockServices();
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.commonServices = new CommonServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            open: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColdefs: [],
            table2Data: [],
            table2ColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            companyName: "",
            idUser: 0,
            roleId: null,
            firstPIList: [],
            secondPIList: [],
            thirdPIList: [],
            pdfLink: "",
            selectItemColDefs: [
                {
                    field: "itemCategory",
                    headerName: "Item Category",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemCategoryDesc",
                    headerName: "Item Category Desc",
                    minWidth: window.innerWidth * 0.06,
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "searchText",
                    headerName: "Search Text",
                    minWidth: window.innerWidth * 0.05,
                    flex: 0.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "drawingNo",
                    headerName: "Drawing No",
                    minWidth: window.innerWidth * 0.08,
                    flex: 0.8,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "itemName",
                    headerName: "Item Name",
                    minWidth: window.innerWidth * 0.15,
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
            ],
            masterTaxStructure: [],
            isSelectItemPopUp: false,
            purchaseObject: {
                idPurchaseOrder: 0,
                updateStatus: 0,
                poNo: '',
                prefix: '',
                poDate: moment(new Date().toISOString()).format('YYYY-MM-DD'),
                idType: 1,
                typeList: [
                    {
                        value: 1,
                        label: 'INTRASTATE'
                    },
                    {
                        value: 2,
                        label: 'INTERSTATE'
                    }
                ],
                modeOfDelivery: '',
                idEmployee: 0,
                employeeList: [],
                idVendor: 0,
                vendorList: [],
                idPoFrom: 1,
                poFromList: [
                    {
                        value: 1,
                        label: 'MANUALLY'
                    },
                    {
                        value: 2,
                        label: 'FROM PURCHASE INQUIRY'
                    }
                ],
                modeOfPayment: '',
                paymentTerms: '',
                idAuthEmployee: 0,
                validity: '',
                address: '',
                deliveryDate: '',
                isClose: false,
                email: '',
                contactNo: "",
                contactPerson: "",
                totalQuantity: "",
                totalAmt: "",
                extraCharges: "",
                totalDiscountAmt: "",
                taxableAmt: "",
                adjustableAmt: "",
                taxAmt: "",
                // totalTaxAmt: "",
                tcsPercentage: "",
                tcsAmt: "",
                finalAmt: "",
                totalwithTax: "",
                idFinancialYear: "",
                e_Date: "",
                invoiceName: "",
                deleteItemsList: [],
            },
            productObject: {
                idPurchaseOrderItems: 0,
                keyId: 0,
                drawingNo: "",
                idMaterialType: 1,
                materialTypeList: [
                    {
                        value: 1,
                        label: 'RAW MATERIAL'
                    },
                    {
                        value: 2,
                        label: 'FINISHED GOODS'
                    },
                    {
                        value: 3,
                        label: 'SEMI FINISHED'
                    },
                    {
                        value: 4,
                        label: 'SCRAP MATERIAL'
                    }
                ],
                idItem: "",
                itemIdLabel: "",
                itemList: [],
                unitList: [],
                idUnit: 0,
                quantity: "",
                rate: "",
                actualRate: "",
                amount: "",
                discount: "",
                discountAmt: "",
                chargesAmt: "",
                total: "",
                idTaxGroup: "",
                taxList: [],
                // sgst: "",
                // cgst: "",
                // igst: "",
                sgst: "",
                sgstAmount: "",
                cgst: "",
                cgstAmount: "",
                igst: "",
                igstAmount: "",
                netTotal: "",
                startDate: "",
                endDate: "",
                remarks: "",
                inwardStatus: false,
            },
            // paymentDetails: {
            //     totalQuantity: "",
            //     totalAmt: "",
            //     extraCharges: "",
            //     disAmt: "",
            //     taxAmt: "",
            //     totalTaxAmt: "",
            //     tcsPer: "",
            //     tcsAmt: "",
            //     finalAmt: "",
            // },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForWork: {
                idVendor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
                deliveryDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "deliveryDate"
                        ),
                    },
                ],
            },
            validationRules: {
                // deliveryDate: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "deliveryDate"
                //         ),
                //     },
                // ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    // openPopUpForAddingItem = () => {
    //     this.setState({ isModalOpen: true }, () => {
    //         this.resetDetailsFields();
    //     })
    // };
    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetFields();
        this.setState({ isModalOpen: true, itemRowData: [], open: false }, () => {
            this.getAllDropdown();
            this.getPrefixSelectPrefix();
        });
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idPurchaseOrder);
    };

    handleCellClickfirstPIList = (event) => {
        if (event.data.idPurchaseInquiry > 0 && this.state.purchaseObject.idVendor > 0) {
            this.getPurchaseInquirySelectbyIDNotInPurchaseOrder(event.data.idPurchaseInquiry);
        } else if (event.data.idPurchaseInquiry > 0) {
            this.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems2(event.data.idPurchaseInquiry);
        }
        //this.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems2(event.data.idPurchaseInquiry);
    };

    handleCellClickSecondPIList = (event) => {
        if (event.data.idItem > 0 && this.state.purchaseObject.idVendor === 0) {
            this.getItemRateVendorwiseSelect3(event.data.idItem);
        }
    };

    openPopUpFromURLId = (id) => {
        // clear urlId so the post-save redirect (to ledger-report) doesn't misfire
        this.setState({ open: false, urlId: 0 })
        this.resetProductObject()
        this.getTransactionPurchaseOrderSelectbyId(id);
    }

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.setState({ open: false })
        this.resetProductObject()
        this.getTransactionPurchaseOrderSelectbyId(event.data.idPurchaseOrder);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    onItemRowDataClicked = (event) => {
        // this.getMasterExpenseAccountGroupSelectbyID(event.data.idAccountGroup);
        let data = [...this.state.itemRowData];
        //data.idGeneralPurchase = event.data.idGeneralPurchase;
        let getItemData = data[event.data.keyId - 1];
        let details = this.state.productObject;

        details.idPurchaseOrderItems = getItemData.idPurchaseOrderItems;
        details.drawingNo = getItemData.drawingNo;
        details.idMaterialType = getItemData.idMaterialType;
        details.itemIdLabel = getItemData.itemName;
        details.idItem = getItemData.idItem;
        details.idUnit = getItemData.idUnit;
        details.quantity = getItemData.quantity;
        details.rate = getItemData.rate;
        details.actualRate = getItemData.actualRate
        details.amount = Number(getItemData.amount).toFixed(2);
        details.discount = getItemData.discount;
        details.discountAmt = getItemData.discountAmt;
        details.chargesAmt = getItemData.chargesAmt;
        details.total = getItemData.total;
        details.idTaxGroup = getItemData.idTaxGroup;
        details.sgst = getItemData.sgst;
        details.sgstAmount = getItemData.sgstAmount;
        details.cgst = getItemData.cgst;
        details.cgstAmount = getItemData.cgstAmount;
        details.igst = getItemData.igst;
        details.igstAmount = getItemData.igstAmount;
        details.netTotal = Number(getItemData.netTotal).toFixed(2);
        details.startDate = getItemData.startDate;
        details.endDate = getItemData.endDate;
        details.remarks = getItemData.remarks;
        details.keyId = getItemData.keyId;
        details.inwardStatus = getItemData.inwardStatus;
        this.setState({ productObject: details }, () => {
            this.getMasterItemSelectbyIDVendorwiseRate('existing')
        });
    };

    // handleDeleteItem = (keyId) => {
    //     // this.SwalServices
    //     //     .Confirm("Delete","Are you sure ?", "Okay", "Cancel")
    //     //     .then((response) => {
    //     //         if (response) {
    //     let data = this.state.itemRowData.filter((x) => x.keyId != keyId);
    //     this.setState({ itemRowData: data }, () => {
    //         this.SwalServices.Success("Deleted sucessfully.");
    //         this.finalCalculation();
    //         this.resetProductObject();
    //     });
    //     //     }
    //     // });
    // };


    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForWork = () => {
        const newValidState = isValidForm(
            this.state.purchaseObject,
            this.state.validationRulesForWork,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.productObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen, open: false });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForWork = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.purchaseObject;
        if (name === "isClose") {
            details.isClose = !details.isClose;
        } else {
            details[name] = value;
        }
        this.setState({ purchaseObject: details });
    }
    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.productObject;
        details[name] = value;
        this.setState({ productObject: details }, () => {
            this.calculatePricing();
        });
    }
    handleChangeForPayment = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.purchaseObject;
        details[name] = value;
        this.setState({ purchaseObject: details }, () => {
            this.finalCalculation();
        });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.purchaseObject;
        let value = event.value;
        details[name] = value;
        this.setState({ purchaseObject: details }, () => {
            if (name === 'idVendor') {
                this.getPartyAccountSelectbyID()
            }
            else if (name === 'idType') {
                this.POdisableControls()
            }
        });
    }

    handleChangeForDropdownForProductObject = (event, name) => {
        let details = this.state.productObject;
        let value = event.value;
        details[name] = value;
        this.setState({ productObject: details }, () => {
            if (name === 'idMaterialType') {
                let details = this.state.productObject
                details.itemIdLabel = ''
                details.idItem = 0
                this.setState({ productObject: details })
                this.getMasterItemSelectbyItemTypeVendorwise()
            } else if (name === 'idItem') {
                this.getMasterItemSelectbyIDVendorwiseRate()
            } else if (name === 'idTaxGroup') {
                this.getTaxStructureSelectbyID()
            }
        });
    }

    POdisableControls = () => {
        if (this.state.purchaseObject.idPoFrom === 1) {
            this.disableControls(false)
        } else if (this.state.purchaseObject.idPoFrom === 2) {
            this.disableControls(true)
        }
    }

    disableControls = (res) => {
        // txtDrawingNo.Enabled = cmbItemType.Enabled = cmbItem.Enabled = txtQty.Enabled = txtRate.Enabled =
        //     txtAmount.Enabled = txtDiscount.Enabled = txtChargesAmt.Enabled = txtNetTotal.Enabled =
        //     cmbTaxGroup.Enabled = txtNetTotal.Enabled = txtItemRemarks.Enabled =
        //     btnInsert.Enabled = btnClear.Enabled = btnDelete.Enabled = res;
    }

    deleteItem = (keyId) => {
        let data = this.state.purchaseObject;
        let idPurchaseOrderItems = this.state.itemRowData?.find(item => item.keyId == keyId)?.idPurchaseOrderItems;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }
        //data.itemList = filterData;
        if (idPurchaseOrderItems > 0) {
            data.deleteItemsList.push(idPurchaseOrderItems);
        }
        this.setState({ purchaseObject: { ...data }, itemRowData: filterData }, () => {
            this.resetProductObject();
            this.finalCalculation();
        });
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId != null) {
                this.setState({ urlId: urlId });
            }
        }
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, roleId: prop.roleId, idUser: prop.idUser ? prop.idUser : 0, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.getAllDropdown();
                this.getMaster_TaxStructure();
                this.getPrefixSelectPrefix();
                this.usp_GetAllUsers();
                //this.getPurchaseInquirySelectNotinPurchaseOrder2();
            }, () => {
                if (this.gridApi) {
                    this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                }
            });
        } else {
            // window.location.href = "/Login";
        }
        setTimeout(() => {
            //this.removeDefaultBorders();
        }, 100)
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Purchase Order",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: this.state.idUser,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            width: this.getPinnedWidth(key),
                            hide: ["idPurchaseOrder",].includes(key),
                            pinned: ["sR.No", "poNo", "poDate", "deliveryDate", "vendor"].includes(key) ? "left" : null,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("poDate") || key.includes("deliveryDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Purchase Order",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            this.getPrefixSelectPrefix();
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            } else {
                if (this.gridApi) {
                    this.gridApi.hideOverlay();
                    this.gridApi.showNoRowsOverlay();
                }
                this.getPrefixSelectPrefix();
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    // openPopUpFromURLId = (id) => {
    //     let details = this.state.materialInwardDetails;
    //     details.idGeneralPurchase = id;
    //     this.setState({ materialInwardDetails: details }, () => {
    //         this.getTransaction_GeneralPurchaseSelectbyId();
    //     });
    // };

    getColumnWidth = (key) => {
        const colwidth = {

            "contactNo": window.innerWidth * 0.08,
            "contactPerson": window.innerWidth * 0.15,
            "totalQty": window.innerWidth * 0.07,
            "totalAmt": window.innerWidth * 0.07,
            "extraCharges": window.innerWidth * 0.07,
            "discount": window.innerWidth * 0.06,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.05,
            "inwardNo": window.innerWidth * 0.06,
            "inwardStatus": window.innerWidth * 0.08,
            "variationStatus": window.innerWidth * 0.05,
            "approvalStatus": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "sR.No": window.innerWidth * 0.05,
            "poNo": window.innerWidth * 0.05,
            "poDate": window.innerWidth * 0.08,
            "deliveryDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.15,
        }
        return pinnedWidths[key];
    }

    procSelectAllRecord2GridviewSP = (id) => {
        //debugger;
        let request = {
            id: id,
            formname: "Purchase Order",
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        //debugger
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    //debugger;
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            minWidth: this.table2ColWidth(key),
                            pinned: this.table2PinnedWidth(key) ? "left" : null,
                            width: this.table2ColWidth(key),
                        }));

                        let filteredData = this.state.roleId !== 1 ? dynamicData.filter((x) => x.pendingQty > 0) : dynamicData
                        this.setState({
                            table2Data: filteredData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        });
                    }
                }
            });
        }
    }

    table2ColWidth = (key) => {
        const colWidth = {

            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.06,
            "taxableAmt": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.05,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.05,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.05,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
            "isVariation": window.innerWidth * 0.06,
            "recvQty": window.innerWidth * 0.06,
            "pendingQty": window.innerWidth * 0.06,
        }
        return colWidth[key];
    }
    table2PinnedWidth = (key) => {
        const pinnedWidths = {
            "drawingNo": window.innerWidth * 0.1,
            "itemCategory": window.innerWidth * 0.15,
            "itemName": window.innerWidth * 0.15,
        }
        return pinnedWidths[key];
    }

    getPrefixSelectPrefix = () => {
        let request = {
            formname: "FrmTransactionPurchaseOrder",
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
        };
        this.accountTransactionServices.getPrefixSelectPrefix(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let dt = this.state.purchaseObject;
                if (data) {
                    dt.prefix = data.prefix;
                }
                this.setState({ purchaseObject: dt }, () => {
                    this.getNoCount();
                });
            } else {
                this.getNoCount();
            }
        });
    }

    getNoCount = () => {
        let request = [this.state.idCompany, 0];
        this.transactionStockServices.usp_Transaction_PurchaseOrderCount(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let total = response.responseItem.responseContent[0].count;
                // debugger;
                let details = this.state.purchaseObject;
                let maxIdPaymentMake = total > 0
                    ? total
                    : 0;
                let inwardNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                details.poNo = details.prefix + inwardNo;
                this.setState({ purchaseObject: details }, () => {
                    //this.getNetworkConfiguration();
                })
            }
        });
    }

    getAllDropdown = () => {
        let request = [this.state.idCompany, 0];
        this.transactionStockServices.getAllDropdown(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let purchaseObject = this.state.purchaseObject;
                let productObject = this.state.productObject;
                //data.vendorList = allData.filter(item => item.source === 'Master_PartyAccount')?.[0].value + 1;
                purchaseObject.vendorList = allData.filter(item => item.source === 'Master_PartyAccount');
                productObject.unitList = allData.filter(item => item.source === 'Master_Unit');
                productObject.taxList = allData.filter(item => item.source === 'Master_TaxStructure');
                this.setState({
                    purchaseObject: purchaseObject,
                    productObject: productObject
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getMaster_TaxStructure = () => {
        this.transactionStockServices.getMaster_TaxStructure().then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                //let masterTaxStructure = this.state.masterTaxStructure;
                this.setState({
                    masterTaxStructure: allData
                });
            }
        });
    }

    getPartyAccountSelectbyID = () => {
        if (this.state.purchaseObject.idVendor > 0) {
            this.accountTransactionServices.getPartyAccountSelectbyID(this.state.purchaseObject.idVendor).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.purchaseObject;
                    //data.modeOfPayment = res.paymentTerms;
                    data.address = res.p_Address;
                    data.paymentTerms = res.paymentTerms;
                    data.email = res.emailID; //  data.inwardType?.find(item => item.name === res.invoiceType)?.id;
                    data.contactNo = res.contactNo;
                    data.contactPerson = res.contactPerson;
                    this.setState({ purchaseObject: data }, () => {
                        this.getMasterItemSelectbyItemTypeVendorwise();
                    });
                }
            });
        }
    }

    getMasterItemSelectbyItemTypeVendorwise = () => {
        if (this.state.purchaseObject.idVendor > 0) {
            let request = [
                this.state.idCompany,
                this.state.productObject.materialTypeList?.find(x => x.value === this.state.productObject.idMaterialType)?.label,
                this.state.purchaseObject.idVendor
            ];
            this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let allData = response.responseItem.responseContent;
                    let data = this.state.productObject;
                    data.itemList = allData;
                    this.setState({
                        productObject: data
                    });
                } else {
                    //this.usp_Master_EmployeeSelect()
                }
            });
        } else {
            this.SwalServices.Alert("Please Select Vendor First");
        }
    }

    getMasterItemSelectbyIDVendorwiseRate = (from) => {
        let request = [
            this.state.productObject.idItem,
            this.state.purchaseObject.idVendor
        ];
        this.transactionStockServices.getMasterItemSelectbyIDVendorwiseRate(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent[0];
                let data = this.state.productObject;
                data.drawingNo = allData.drawingNo;
                data.idMaterialType = data.materialTypeList.find(x => x.label === allData.itemType)?.value;  // chack please
                data.rate = from === 'existing' ? data.rate : allData.finalItemRate;
                data.actualRate = from === 'existing' ? data.actualRate : allData.finalItemRate;
                data.idTaxGroup = allData.idTaxGroup;
                data.idUnit = allData.idUnit;
                data.startDate = allData.startDate ? moment(allData.startDate).format('YYYY-MM-DD') : moment(new Date().toISOString()).format('YYYY-MM-DD');
                data.endDate = allData.endDate ? moment(allData.endDate).format('YYYY-MM-DD') : moment(new Date().toISOString()).format('YYYY-MM-DD');
                // txtDrawingNo.Text = dr["DrawingNo"].ToString();
                //     cmbItemType.Text = dr["ItemType"].ToString();
                //     txtRate.Text = dr["FinalItemRate"].ToString();
                //     txtActualRate.Text = dr["FinalItemRate"].ToString();
                //     cmbTaxGroup.EditValue = Convert.ToInt32(dr["IDTaxGroup"]);
                //     cmbUnit.EditValue = Convert.ToInt32(dr["IDUnit"]);
                //     dtStart.Text = string.IsNullOrEmpty(dr["StartDate"].ToString())
                //      ? string.Empty
                //      : Convert.ToDateTime(dr["StartDate"].ToString()).ToString("dd/MM/yyyy");
                //     dtStart.EditValue = string.IsNullOrEmpty(dr["StartDate"].ToString())
                //         ? (DateTime?)DateTime.Today
                //         : Convert.ToDateTime(dr["StartDate"].ToString());
                //     dtEnd.Text = string.IsNullOrEmpty(dr["EndDate"].ToString())
                //      ? string.Empty
                //      : Convert.ToDateTime(dr["EndDate"].ToString()).ToString("dd/MM/yyyy");
                //     dtEnd.EditValue = string.IsNullOrEmpty(dr["EndDate"].ToString())
                //         ? (DateTime?)DateTime.Today
                //         : Convert.ToDateTime(dr["EndDate"].ToString());

                this.setState({
                    productObject: data
                }, () => {
                    this.getTaxStructureSelectbyID();
                    //this.calcQtyRate();
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getTaxStructureSelectbyID = () => {
        if (this.state.productObject.idTaxGroup > 0) {
            this.accountTransactionServices.getTaxStructureSelectbyID(this.state.productObject.idTaxGroup).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.productObject;
                    data.sgst = res.sgst;
                    data.cgst = res.cgst;
                    data.igst = res.igst;
                    this.setState({ productObject: data }, () => {
                        this.calculatePricing();
                    });
                }
            });
        }
    }

    calculatePricing = () => {
        if (this.state.productObject.rate) {
            let productObject = this.state.productObject;
            let purchaseObject = this.state.purchaseObject;
            productObject.total = 0;
            productObject.sgstAmount = 0;
            productObject.cgstAmount = 0;
            productObject.igstAmount = 0;
            productObject.netTotal = 0;
            productObject.amount = 0
            productObject.discountAmt = 0;
            productObject.amount = (Number(productObject.quantity) * Number(productObject.rate)).toFixed(2);
            productObject.total = Number(productObject.amount);
            productObject.discountAmt = (Number(productObject.amount) / 100) * Number(productObject.discount);
            productObject.total = productObject.total - productObject.discountAmt;
            productObject.total = productObject.total + Number(productObject.chargesAmt);
            productObject.sgstAmount = purchaseObject.idType === 1 ? Number(((productObject.total * productObject.sgst) / 100).toFixed(2)) : 0;
            productObject.cgstAmount = purchaseObject.idType === 1 ? Number(((productObject.total * productObject.cgst) / 100).toFixed(2)) : 0;
            productObject.igstAmount = Number(productObject.igst) > 0 ? purchaseObject.idType === 1 ? 0 : Number(((productObject.total * productObject.igst) / 100).toFixed(2)) : 0;
            productObject.netTotal = (
                Number(productObject.total) +
                Number(productObject.sgstAmount) +
                Number(productObject.cgstAmount) +
                Number(productObject.igstAmount)
            ).toFixed(2);
            this.setState({ productObject: productObject });
        }
    }

    finalCalculation = () => {
        let data = this.state.itemRowData;
        let finalAmountCal = this.state.purchaseObject;

        finalAmountCal.totalQuantity = 0;
        finalAmountCal.totalAmt = 0;
        finalAmountCal.extraCharges = 0;
        finalAmountCal.totalDiscountAmt = 0;
        finalAmountCal.taxAmt = 0;
        finalAmountCal.totalwithTax = 0;
        finalAmountCal.tcsAmt = 0;
        finalAmountCal.taxableAmt = 0;
        // finalAmountCal.totalTaxAmt = 0;
        finalAmountCal.finalAmt = 0;

        data.map((x) => {
            finalAmountCal.totalQuantity += Number(x.quantity);
            finalAmountCal.totalAmt += Number(x.amount);
            finalAmountCal.extraCharges += Number(x.chargesAmt);
            finalAmountCal.totalDiscountAmt += Number(x.discountAmt);
            finalAmountCal.taxAmt += Number(x.sgstAmount) + Number(x.cgstAmount) + Number(x.igstAmount);
            finalAmountCal.finalAmt += Number(x.netTotal);
            finalAmountCal.taxableAmt += Number(x.total)
        });

        finalAmountCal.totalwithTax =
            (Number(finalAmountCal.totalAmt) - Number(finalAmountCal.totalDiscountAmt)) +
            Number(finalAmountCal.extraCharges) +
            Number(finalAmountCal.taxAmt);

        finalAmountCal.tcsAmt = Number(finalAmountCal.tcsPercentage) > 0
            ? (finalAmountCal.totalwithTax * Number(finalAmountCal.tcsPercentage)) / 100
            : 0;

        finalAmountCal.finalAmt = Number(finalAmountCal.totalwithTax + finalAmountCal.tcsAmt).toFixed(2);

        finalAmountCal.taxableAmt = Number(finalAmountCal.taxableAmt).toFixed(2)
        finalAmountCal.totalAmt = Number(finalAmountCal.totalAmt).toFixed(2);
        finalAmountCal.extraCharges = Number(finalAmountCal.extraCharges).toFixed(2);
        finalAmountCal.totalDiscountAmt = Number(finalAmountCal.totalDiscountAmt).toFixed(2);
        finalAmountCal.taxAmt = Number(finalAmountCal.taxAmt).toFixed(2);
        finalAmountCal.tcsAmt = Number(finalAmountCal.tcsAmt).toFixed(2);
        finalAmountCal.totalwithTax = Number(finalAmountCal.totalwithTax).toFixed(2);
        finalAmountCal.finalAmt = Math.round(Number(finalAmountCal.finalAmt) + (Number(finalAmountCal.adjustableAmt) || 0));

        this.setState({ purchaseObject: finalAmountCal });
    }


    isDateInRange = (date, startDate, endDate) => {
        const dt = new Date(date);
        const start = new Date(startDate);
        const end = new Date(endDate);

        if (isNaN(dt) || isNaN(start) || isNaN(end)) {
            return false;
        }

        return dt >= start && dt <= end;
    }


    insertItem = (flag) => {
        //const isValidAllFields = this.isValidInwardFields();
        if (this.isDateInRange(this.state.purchaseObject.poDate, this.state.productObject.startDate, this.state.productObject.endDate)) {
            if (flag === 'Insert') {
                let details = this.state.productObject;
                let array = this.state.itemRowData;

                const isItemExists = array.some(x => x.idItem === details.idItem);

                if (isItemExists) {
                    this.SwalServices.Error("This item is already added.");
                    return;
                }
                // debugger;
                let itemList = [...this.state.itemRowData];
                let obj = {
                    //idPurchaseOrderItems: 0,
                    drawingNo: details.drawingNo,
                    idMaterialType: details.idMaterialType,
                    materialType: details.materialTypeList.find(x => x.value === details.idMaterialType)?.label,
                    idItem: details.idItem,
                    itemName: details.itemIdLabel,
                    idUnit: details.idUnit,
                    quantity: Number(details.quantity),
                    rate: details.rate,
                    actualRate: details.actualRate,
                    amount: Number(details.amount),
                    discount: Number(details.discount),
                    discountAmt: Number(details.discountAmt),
                    chargesAmt: Number(details.chargesAmt),
                    total: Number(details.total),
                    idTaxGroup: details.idTaxGroup,
                    sgst: details.sgst,
                    sgstAmount: Number(details.sgstAmount),
                    cgst: details.cgst,
                    cgstAmount: Number(details.cgstAmount),
                    igst: details.igstAmount > 0 ? details.igst : 0,
                    igstAmount: Number(details.igstAmount),
                    netTotal: Number(details.netTotal),
                    startDate: details.startDate,
                    endDate: details.endDate,
                    remarks: details.remarks,
                    idPurchaseInquiry: 0,
                    idPurchaseInquiryItems: 0,
                    idPurchaseOrderItems: 0,
                    idMaterialPlanning: 0,
                    idMaterialPlanningDetails: 0,
                }
                itemList.push(obj);
                itemList.map((x, key) => {
                    x.keyId = key + 1;
                });
                this.setState({ itemRowData: itemList }, () => {
                    this.resetProductObject();
                    this.finalCalculation();
                });
            }
            else if (flag === 'Update') {
                let details2 = this.state.productObject;
                let itemList2 = [...this.state.itemRowData];
                let obj2 = {
                    //idPurchaseOrderItems: details2.idPurchaseOrderItems,
                    drawingNo: details2.drawingNo,
                    idMaterialType: details2.idMaterialType,
                    materialType: details2.materialTypeList.find(x => x.value === details2.idMaterialType)?.label,
                    idItem: details2.idItem,
                    itemIdLabel: details2.itemIdLabel,
                    itemName: details2.itemIdLabel,
                    idUnit: details2.idUnit,
                    quantity: Number(details2.quantity),
                    rate: Number(details2.rate),
                    actualRate: Number(details2.actualRate),
                    amount: Number(details2.amount),
                    discount: Number(details2.discount),
                    discountAmt: Number(details2.discountAmt),
                    chargesAmt: Number(details2.chargesAmt),
                    total: Number(details2.total),
                    idTaxGroup: details2.idTaxGroup,
                    sgst: details2.sgst,
                    sgstAmount: Number(details2.sgstAmount),
                    cgst: details2.cgst,
                    cgstAmount: Number(details2.cgstAmount),
                    igst: details2.igstAmount > 0 ? details2.igst : 0,
                    igstAmount: Number(details2.igstAmount),
                    netTotal: Number(details2.netTotal),
                    startDate: details2.startDate,
                    endDate: details2.endDate,
                    remarks: details2.remarks,
                    idPurchaseInquiry: details2.idPurchaseInquiry,
                    idPurchaseInquiryItems: details2.idPurchaseInquiryItems,
                    idPurchaseOrderItems: details2.idPurchaseOrderItems,
                    idMaterialPlanning: details2.idMaterialPlanning,
                    idMaterialPlanningDetails: details2.idMaterialPlanningDetails,
                };
                itemList2[details2.keyId - 1] = obj2;
                itemList2.map((x, key) => {
                    x.keyId = key + 1;
                });
                this.setState({ itemRowData: itemList2 }, () => {
                    this.resetProductObject();
                    this.finalCalculation();
                });
            }
        } else {
            this.SwalServices.Alert("Please Enter Valid Data");
        }
    }

    resetProductObject = () => {
        let details = this.state.productObject;
        details.idPurchaseOrderItems = 0;
        details.idMaterialPlanning = 0;
        details.idMaterialPlanningDetails = 0;
        details.drawingNo = 0;
        details.idMaterialType = 1;
        details.idItem = 0;
        details.itemIdLabel = "";
        details.idUnit = 0;
        //details.unitDescription = "";
        details.quantity = 0;
        details.rate = 0;
        details.actualRate = 0;
        details.amount = 0;
        details.discount = 0;
        details.discountAmt = 0;
        details.chargesAmt = 0;
        details.total = 0;
        //details.idTaxStructure = "";
        //details.taxStructureName = "";
        details.idTaxGroup = "";
        //details.taxGroup = "";
        details.sgst = "";
        details.sgstAmount = "";
        details.cgst = "";
        details.cgstAmount = "";
        details.igst = "";
        details.igstAmount = "";
        details.netTotal = "";
        details.startDate = "";
        details.endDate = "";
        details.remarks = "";
        details.keyId = "";
        this.setState({ productObject: details })
    }

    submit = () => {
        if (this.isSubmitting) { return; }
        const isValidAllFieldsForWork = this.isValidAllFieldsForWork();
        if (isValidAllFieldsForWork) {
            let purchaseOrderDate = moment(this.state.purchaseObject.poDate);
            let delDate = moment(this.state.purchaseObject.deliveryDate);
            if (this.state.itemRowData.length === 0) {
                this.SwalServices.Alert("Please add product items details");
            } else if (purchaseOrderDate.isAfter(delDate)) {
                this.SwalServices.Alert("Delivery date should be greater than or equal to PO date");
            } else {
                let data = this.state.purchaseObject
                let productObject = this.state.productObject;
                let request = {
                    idPurchaseOrder: data.idPurchaseOrder,
                    updateStatus: data.updateStatus,
                    poNo: data.poNo,
                    poDate: data.poDate && data.poDate !== 'Invalid date' ? data.poDate : null,
                    idPartyAccount: data.idVendor,
                    poType: data.typeList.find(x => x.value === data.idType)?.label,
                    poFrom: data.poFromList.find(x => x.value === data.idPoFrom)?.label,
                    modeOfDelivery: data.modeOfDelivery,
                    modeOfPayment: data.modeOfPayment,
                    paymentTerms: data.paymentTerms,
                    idAuthEmployee: data.idAuthEmployee,
                    poValidity: data.validity,
                    deliveryDate: data.deliveryDate && data.deliveryDate !== 'Invalid date' ? data.deliveryDate : null,
                    totalQty: data.totalQuantity,
                    totalAmt: data.totalAmt,
                    taxAmt: data.taxAmt,
                    totalwithTax: data.totalwithTax,
                    taxableAmt: data.taxableAmt,
                    extraCharges: data.extraCharges,
                    discount: data.totalDiscountAmt,
                    finalAmt: data.finalAmt,
                    remarks: "",
                    idCompany: this.state.idCompany,
                    e_Date: data.e_Date ? moment(data.e_Date).format('YYYY-MM-DD') : new Date().toISOString(),
                    //e_IDUser: this.state.idUser,
                    e_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isUpdated: data.updateStatus === 1 ? true : false,
                    updatedDate: data.updateStatus === 1 ? moment(new Date().toISOString()).format('YYYY-MM-DD') : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: null,
                    prefix: data.prefix,
                    isClosed: data.isClose,
                    tcsPercentage: data.tcsPercentage,
                    tcsAmt: data.tcsAmt,
                    idFinancialYear: data.idFinancialYear,
                    adjustableAmt: data.adjustableAmt
                    //itemList:
                };
                request.deleteItemsList = data.deleteItemsList;
                request.itemList = [];
                let itemList = this.state.itemRowData;
                //let details = this.state.productObject;
                itemList.map((details) => {
                    let obj = {
                        idPurchaseOrderItems: details.idPurchaseOrderItems,
                        idPurchaseOrder: data.idPurchaseOrder,
                        drawingNo: details.drawingNo,
                        itemType: productObject.materialTypeList.find(x => x.value === details.idMaterialType)?.label,
                        idItem: details.idItem,
                        quantity: details.quantity,
                        invoiceRate: null,
                        rate: details.rate,
                        actualRate: details.actualRate,
                        isVariation: details.rate > details.actualRate ? true : false,
                        poAmount: null,
                        amount: details.amount,
                        discount: details.discount,
                        extraCharges: details.chargesAmt,
                        poTaxableAmt: null,//details.tot,
                        taxableAmt: details.total,
                        sgst: details.sgst,
                        sgstAmt: details.sgstAmount,
                        cgst: details.cgst,
                        cgstAmt: details.cgstAmount,
                        igst: details.igst,
                        igstAmt: details.igstAmount,
                        netTotal: details.netTotal,
                        idTaxGroup: details.idTaxGroup,
                        idPurchaseInquiry: details.idPurchaseInquiry,
                        idPurchaseInquiryItems: details.idPurchaseInquiryItems,
                        idPoItem: details.idPurchaseOrderItems,
                        itemRemarks: details.remarks,
                        idMaterialPlanning: 0,
                        idMaterialPlanningDetails: 0,
                        startDate: moment(details.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                        endDate: moment(details.endDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                        idMaterialPlanning: details.idMaterialPlanning,
                        idMaterialPlanningDetails: details.idMaterialPlanningDetails,
                    }
                    request.itemList.push(obj);
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.transactionStockServices.submitPurchaseOrder(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        if (data !== null) {
                            if (this.state.purchaseObject.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.setState({
                                    isModalOpen: false,
                                    //receiptDetails: reset
                                }, () => {
                                    this.resetFields();
                                    this.procSelectAllRecordsSP();
                                });
                            }
                        }
                    }
                }).finally(() => { this.isSubmitting = false; this.setState({ isSaving: false }); });
            }
        }
    }

    resetFields = () => {
        let data = this.state.purchaseObject;
        data.idPurchaseOrder = 0;
        data.updateStatus = 0;
        data.poNo = '';
        data.prefix = '';
        data.poDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        data.idType = 1;
        data.modeOfDelivery = '';
        data.idEmployee = 0;
        // data.employeeList = [];
        data.idVendor = 0;
        // data.vendorList = [];
        data.idPoFrom = 1;
        data.modeOfPayment = '';
        data.paymentTerms = '';
        data.idAuthEmployee = 0;
        data.validity = '';
        data.address = '';
        data.deliveryDate = '';
        data.isClose = false;
        data.email = '';
        data.totalQuantity = "";
        data.totalAmt = "";
        data.extraCharges = "";
        data.totalDiscountAmt = "";
        data.taxAmt = "";
        // data.totalTaxAmt = "";
        data.tcsPercentage = "";
        data.tcsAmt = "";
        data.taxableAmt = "";
        data.adjustableAmt = "";
        data.finalAmt = "";
        data.idFinancialYear = "";
        data.e_Date = "";
        data.invoiceName = "";
        this.setState({ purchaseObject: data, pdfLink: "" }, () => {
            this.resetProductObject();
        })
    }

    toNumber = (value, fixed = null) => {
        const num = Number(value);
        if (isNaN(num)) return 0;
        return fixed !== null ? Number(num.toFixed(fixed)) : num;
    };

    getTransactionPurchaseOrderSelectbyId = (idPurchaseOrder) => {
        if (idPurchaseOrder > 0) {
            this.transactionStockServices.getTransactionPurchaseOrderSelectbyId(idPurchaseOrder).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let itemListRecords = response.responseItem.responseContent[1];
                    if (this.state.roleId !== 1) {
                        itemListRecords = itemListRecords.filter(x => Number(x.pendingQty) > 0);
                    }
                    let itemList = [];
                    let purchaseObject = this.state.purchaseObject;
                    purchaseObject.idPurchaseOrder = res.idPurchaseOrder;
                    purchaseObject.updateStatus = 1;
                    purchaseObject.poNo = res.poNo;
                    //purchaseObject.prefix = '';
                    purchaseObject.poDate = res.poDate ? moment(res.poDate).format('YYYY-MM-DD') : '';
                    purchaseObject.idType = purchaseObject.typeList.find(x => x.label === res.poType)?.value;
                    purchaseObject.modeOfDelivery = res.modeOfDelivery;
                    purchaseObject.idEmployee = 0;
                    purchaseObject.employeeList = [];
                    purchaseObject.idVendor = res.idPartyAccount;
                    //purchaseObject.vendorList = [];
                    purchaseObject.idPoFrom = purchaseObject.poFromList.find(x => x.label === res.poFrom)?.value;
                    purchaseObject.modeOfPayment = res.modeOfPayment;
                    purchaseObject.paymentTerms = res.paymentTerms;
                    purchaseObject.idAuthEmployee = 0;
                    purchaseObject.validity = res.poValidity;
                    purchaseObject.address = ""; //res.address;
                    purchaseObject.deliveryDate = res.deliveryDate ? moment(res.deliveryDate).format('YYYY-MM-DD') : '';
                    purchaseObject.isClose = res.isClosed;
                    //purchaseObject.email = '';
                    purchaseObject.totalQuantity = res.totalQty;
                    purchaseObject.totalAmt = res.totalAmt;
                    purchaseObject.taxableAmt = res.taxableAmt;
                    purchaseObject.adjustableAmt = res.adjustableAmt;
                    purchaseObject.extraCharges = res.extraCharges;
                    purchaseObject.totalDiscountAmt = res.discount;
                    purchaseObject.taxAmt = res.taxAmt;
                    // purchaseObject.totalTaxAmt = res.taxAmt;
                    purchaseObject.totalwithTax = res.totalwithTax;
                    purchaseObject.tcsPercentage = res.tcsPercentage;
                    purchaseObject.tcsAmt = res.tcsAmt;
                    purchaseObject.finalAmt = res.finalAmt;
                    purchaseObject.idFinancialYear = "";
                    purchaseObject.e_Date = res.e_Date;
                    purchaseObject.invoiceName = res.invoiceName;

                    itemListRecords.map((details, keyId) => {

                        let rate = this.toNumber(details.rate, 2);
                        let amount = this.toNumber(details.amount, 2);
                        let discount = this.toNumber(details.discount);
                        let discountAmt = discount > 0 ? this.toNumber((amount * discount) / 100, 2) : 0;
                        let taxableAmt = this.toNumber(details.taxableAmt, 2);

                        let obj = {
                            idPurchaseOrderItems: details.idPurchaseOrderItems,
                            drawingNo: details.drawingNo,
                            materialType: details.itemType,
                            idMaterialType: this.state.productObject.materialTypeList?.find(x => x.label === details.itemType)?.value,
                            idItem: details.idItem,
                            itemName: details.itemName,
                            //idUnit: details.idUnit,
                            quantity: this.toNumber(details.quantity),

                            rate: rate,
                            actualRate: this.toNumber(details.actualRate),
                            amount: amount,

                            discount: discount,
                            discountAmt: discountAmt,

                            chargesAmt: this.toNumber(details.extraCharges),

                            total: taxableAmt,
                            idTaxGroup: details.idTaxGroup,
                            sgst: this.toNumber(details.sgst),
                            sgstAmount: this.toNumber(details.sgstAmt),

                            cgst: this.toNumber(details.cgst),
                            cgstAmount: this.toNumber(details.cgstAmt),

                            igst: this.toNumber(details.igst),
                            igstAmount: this.toNumber(details.igstAmt),

                            netTotal: this.toNumber(details.netTotal) || this.fixedNetTotalAmount(details),
                            startDate: details.startDate ? moment(details.startDate).format('DD-MM-YYYY') : '',
                            endDate: details.endDate ? moment(details.endDate).format('DD-MM-YYYY') : '',
                            remarks: details.itemRemarks,
                            keyId: keyId + 1,
                            idMaterialPlanning: details.idMaterialPlanning > 0 ? details.idMaterialPlanning : 0,
                            idMaterialPlanningDetails: details.idMaterialPlanningDetails > 0 ? details.idMaterialPlanningDetails : 0,
                            inwardStatus: details.inwardStatus,
                            pendingQty: details.pendingQty ? details.pendingQty : 0,
                            recvQty: details.recvQty ? details.recvQty : 0
                        }
                        itemList.push(obj);
                    })

                    let req = [
                        this.state.idCompany,
                        itemListRecords[0]?.itemType,
                        this.state.purchaseObject.idVendor
                    ];
                    // this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(req).then((response2) => {
                    //     if (response2.statusCode == 200 && response2.responseItem !== null) {
                    //         let allData = response2.responseItem.responseContent;
                    //         let data = this.state.productObject;
                    //         allData = allData.map((x) => ({
                    //             value: x.idItem,
                    //             label: x.itemCategory + ' - ' + x.drawingNo + ' - ' + x.itemName,
                    //         }));
                    //         data.itemList = allData;
                    //         this.setState({
                    //             productObject: data
                    //         });
                    //         itemList.map((x) => {
                    //             x.itemName = data.itemList.find(x => x.value === x.idItem)?.label;
                    //         });
                    //     }
                    // });
                    let filteredData = this.state.roleId !== 1 ? itemList.filter((x) => x.pendingQty > 0) : itemList
                    this.setState({ purchaseObject: purchaseObject, itemRowData: filteredData, pdfLink: res.pdfLink, globalUserID: res.modifiedBy }, () => {
                        let req = [
                            this.state.idCompany,
                            itemListRecords[0]?.itemItemType,
                            res.idPartyAccount
                        ];
                        this.transactionStockServices.getMasterItemSelectbyItemTypeVendorwise(req).then((response2) => {
                            if (response2.statusCode == 200 && response2.responseItem !== null) {
                                let allData = response2.responseItem.responseContent;
                                //let data = this.state.productObject;
                                let itemRowData = this.state.itemRowData;
                                allData = allData.map((x) => ({
                                    value: x.idItem,
                                    label: x.itemName,
                                }));
                                //data.itemList = allData;
                                // this.setState({s
                                //     productObject: data
                                // }, () => {
                                //     let set = this.state.productObject;
                                // itemRowData.map((y) => {
                                //     y.itemName = allData?.find(x => x.value === y.idItem)?.label ? allData?.find(x => x.value === y.idItem)?.label : "";
                                // });
                                this.setState({ itemRowData: [...filteredData] });
                                // });
                            }
                            this.setState({ isModalOpen: true });
                        });
                        this.getPartyAccountSelectbyID()
                    });
                }
            });
        }
    }

    fixedNetTotalAmount = (details) => {
        var taxableAmt = details.taxableAmt > 0 ? details.taxableAmt : 0;
        var netTotal = taxableAmt + details.sgstAmt + details.cgstAmt + details.igstAmt;
        return netTotal > 0 ? (netTotal).toFixed(2) : 0;
    }
    addPI = () => {
        this.setState({ open: true, firstPIList: [], secondPIList: [], thirdPIList: [] }, () => {
            this.getPurchaseInquirySelectNotinPurchaseOrder2();
        })
    }
    addProduct = () => {
        this.setState({ open: true }, () => {
            this.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems();
        })
    }
    back = () => {
        this.setState({ open: !this.state.open });
    }

    getPurchaseInquirySelectNotinPurchaseOrder2 = () => {
        if (this.state.idCompany > 0) {
            let request = [this.state.purchaseObject.updateStatus, this.state.purchaseObject.idPurchaseOrder, this.state.idCompany];
            this.transactionStockServices.getPurchaseInquirySelectNotinPurchaseOrder2(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent;
                    let data = this.state.firstPIList;
                    let idPurchaseInquiry = 0;
                    data = [];
                    if (res.length > 0) {
                        res.map((x) => {
                            x.Select = false;
                            x.inquiryDate = moment(x.inquiryDate).format("DD-MM-YYYY");
                            // if (x.idPurchaseInquiry === 1) {
                            //     x.Select = true;
                            // }
                        });
                        data = res;
                        idPurchaseInquiry = res[0]?.idPurchaseInquiry;
                    }
                    this.setState({ firstPIList: data }, () => {
                        if (idPurchaseInquiry > 0 && this.state.purchaseObject.idVendor > 0) {
                            this.getPurchaseInquirySelectbyIDNotInPurchaseOrder(idPurchaseInquiry);
                        } else if (idPurchaseInquiry > 0) {
                            this.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems2(idPurchaseInquiry);
                        }
                    });
                }
            });
        }
    }

    getPurchaseInquirySelectbyIDNotInPurchaseOrderItems2 = (idPurchaseInquiry) => {
        if (idPurchaseInquiry > 0) {
            let request = [idPurchaseInquiry, this.state.purchaseObject.idPurchaseOrder, this.state.purchaseObject.updateStatus, this.state.purchaseObject.idVendor];
            this.transactionStockServices.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems2(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[1];
                    let data = [];
                    let idItem = 0;
                    if (res && res.length > 0) {
                        data = res;
                        idItem = res[0]?.idItem;
                    }
                    this.setState({ secondPIList: data }, () => {
                        if (idItem > 0) {
                            this.getItemRateVendorwiseSelect3(idItem);
                        }
                    });
                }
            });
        }
    }

    getPurchaseInquirySelectbyIDNotInPurchaseOrder = (idPurchaseInquiry) => {
        if (idPurchaseInquiry > 0) {
            let request = [idPurchaseInquiry, this.state.purchaseObject.idPurchaseOrder, this.state.purchaseObject.updateStatus, this.state.purchaseObject.idVendor];
            this.transactionStockServices.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[1];
                    let data = [];
                    let idItem = 0;
                    if (res.length > 0) {
                        data = res;
                        idItem = res[0]?.idItem;
                    }
                    this.setState({ secondPIList: data }, () => {
                        if (idItem > 0) {
                            //this.getItemRateVendorwiseSelect3(idItem);
                        }
                    });
                }
            });
        }
    }

    getItemRateVendorwiseSelect3 = (idItem) => {
        if (idItem > 0 && this.state.purchaseObject.idVendor === 0) {
            this.transactionStockServices.getItemRateVendorwiseSelect3(idItem).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent;
                    let data = [];
                    if (res.length > 0) {
                        data = res;
                    }
                    this.setState({ thirdPIList: data }, () => {
                    });
                }
            });
        }
    }

    onSelectionChanged = (selectedRows) => {
        this.setState({ selectedRowsForfirstPIList: selectedRows });
    };

    // getPurchaseInquirySelectbyIDNotInPurchaseOrderItems = async () => {
    //     const { selectedRowsForfirstPIList, purchaseObject, itemRowData, masterTaxStructure, productObject } = this.state;
    //     let updatedItemList = [...itemRowData];

    //     for (const z of selectedRowsForfirstPIList) {
    //         const request = [
    //             z.idPurchaseInquiry,
    //             purchaseObject.idPurchaseOrder,
    //             purchaseObject.updateStatus,
    //             purchaseObject.idVendor
    //         ];

    //         try {
    //             const response = await this.transactionStockServices.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems(request);

    //             if (response.statusCode === 200 && response.responseItem !== null) {
    //                 const res = response.responseItem.responseContent[2];

    //                 if (res && res.length > 0) {
    //                     res.forEach((details) => {
    //                         const itemrate = details.finalItemRate || 0;
    //                         const qty = details.quantity || 0;
    //                         const amt = itemrate * qty;

    //                         const taxStructure = masterTaxStructure?.find(x => x.idTaxStructure === details.itemTaxGroup) || {};
    //                         const sgst = taxStructure.sgst || 0;
    //                         const cgst = taxStructure.cgst || 0;
    //                         const igst = taxStructure.igst || 0;

    //                         const sgstamt = purchaseObject.idType === 1 ? (amt * sgst) / 100 : 0;
    //                         const cgstamt = purchaseObject.idType === 1 ? (amt * cgst) / 100 : 0;
    //                         const igstamt = purchaseObject.idType === 1 ? 0 : (amt * igst) / 100;

    //                         const obj = {
    //                             idPurchaseOrderItems: 0,
    //                             drawingNo: details.itemDrawingNo,
    //                             materialType: details.itemItemType,
    //                             idMaterialType: productObject.materialTypeList?.find(x => x.label === details.itemItemType)?.value,
    //                             idItem: details.idItem,
    //                             itemName: details.itemName,
    //                             quantity: qty,
    //                             rate: itemrate,
    //                             actualRate: details.itemRate,
    //                             amount: amt,
    //                             discount: details.discount || 0,
    //                             discountAmt: 0,
    //                             chargesAmt: 0,
    //                             total: amt,
    //                             idTaxGroup: details.itemTaxGroup,
    //                             sgst,
    //                             sgstAmount: sgstamt,
    //                             cgst,
    //                             cgstAmount: cgstamt,
    //                             igst: igstamt > 0 ? igst : 0,
    //                             igstAmount: igstamt,
    //                             netTotal: Number(amt + sgstamt + cgstamt + igstamt).toFixed(2),
    //                             startDate: "",
    //                             endDate: "",
    //                             remarks: "",
    //                             idPurchaseInquiry: details.idPurchaseInquiry,
    //                             idPurchaseInquiryItems: details.idPurchaseInquiryItems,
    //                         };

    //                         updatedItemList.push(obj);
    //                     });
    //                 }
    //             }
    //         } catch (error) {
    //             console.error("API Error:", error);
    //         }
    //     }

    //     updatedItemList = updatedItemList.map((item, index) => ({
    //         ...item,
    //         keyId: index + 1
    //     }));

    //     this.setState({ itemRowData: updatedItemList, open: false }, () => {
    //         this.finalCalculation();
    //     });
    // };

    getPurchaseInquirySelectbyIDNotInPurchaseOrderItems = async () => {
        const { selectedRowsForfirstPIList, purchaseObject, itemRowData, masterTaxStructure, productObject } = this.state;
        let updatedItemMap = new Map();

        for (const z of selectedRowsForfirstPIList) {
            const request = [
                z.idPurchaseInquiry,
                purchaseObject.idPurchaseOrder,
                purchaseObject.updateStatus,
                purchaseObject.idVendor
            ];

            try {
                const response = await this.transactionStockServices.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems(request);

                if (response.statusCode === 200 && response.responseItem !== null) {
                    const res = response.responseItem.responseContent[2];

                    if (res && res.length > 0) {
                        res.forEach((details) => {
                            const itemrate = details.finalItemRate || 0;
                            const qty = details.quantity || 0;
                            const amt = itemrate * qty;

                            const taxStructure = masterTaxStructure?.find(x => x.idTaxStructure === details.itemTaxGroup) || {};
                            const sgst = taxStructure.sgst || 0;
                            const cgst = taxStructure.cgst || 0;
                            const igst = taxStructure.igst || 0;

                            const sgstamt = purchaseObject.idType === 1 ? (amt * sgst) / 100 : 0;
                            const cgstamt = purchaseObject.idType === 1 ? (amt * cgst) / 100 : 0;
                            const igstamt = purchaseObject.idType === 1 ? 0 : (amt * igst) / 100;

                            const key = `${details.idItem}_${details.itemDrawingNo}_${details.itemName}`;

                            if (updatedItemMap.has(key)) {
                                // Item already exists: sum values
                                const existing = updatedItemMap.get(key);
                                existing.quantity = Number(existing.quantity + qty).toFixed(2);
                                existing.amount = Number(existing.amount + amt).toFixed(2);
                                existing.total = Number(existing.total + amt).toFixed(2);
                                existing.sgstAmount = Number(existing.sgstAmount + sgstamt).toFixed(2);
                                existing.cgstAmount = Number(existing.cgstAmount + cgstamt).toFixed(2);
                                existing.igstAmount = Number(existing.igstAmount + igstamt).toFixed(2);
                                existing.netTotal = Number(
                                    Number(existing.amount) +
                                    Number(existing.sgstAmount) +
                                    Number(existing.cgstAmount) +
                                    Number(existing.igstAmount)
                                ).toFixed(2);
                            } else {
                                // New item: create entry
                                updatedItemMap.set(key, {
                                    idPurchaseOrderItems: details.idPurchaseOrderItems || 0,
                                    drawingNo: details.itemDrawingNo,
                                    materialType: details.itemItemType,
                                    idMaterialType: productObject.materialTypeList?.find(x => x.label === details.itemItemType)?.value,
                                    idItem: details.idItem,
                                    itemName: details.itemName,
                                    quantity: Number(qty).toFixed(2),
                                    rate: Number(itemrate).toFixed(2),
                                    actualRate: Number(details.itemRate).toFixed(2),
                                    amount: Number(amt).toFixed(2),
                                    discount: Number(details.discount || 0).toFixed(2),
                                    discountAmt: Number(0).toFixed(2),
                                    chargesAmt: Number(0).toFixed(2),
                                    total: Number(amt).toFixed(2),
                                    idTaxGroup: details.itemTaxGroup,
                                    sgst: Number(sgst).toFixed(2),
                                    sgstAmount: Number(sgstamt).toFixed(2),
                                    cgst: Number(cgst).toFixed(2),
                                    cgstAmount: Number(cgstamt).toFixed(2),
                                    igst: Number(igstamt > 0 ? igst : 0).toFixed(2),
                                    igstAmount: Number(igstamt).toFixed(2),
                                    netTotal: Number(amt + sgstamt + cgstamt + igstamt).toFixed(2),
                                    startDate: "",
                                    endDate: "",
                                    remarks: "",
                                    idPurchaseInquiry: details.idPurchaseInquiry,
                                    idPurchaseInquiryItems: details.idPurchaseInquiryItems,
                                    idMaterialPlanning: details.idMaterialPlanning,
                                    idMaterialPlanningDetails: details.idMaterialPlanningDetails,
                                });
                            }
                        });
                    }
                }
            } catch (error) {
                console.error("API Error:", error);
            }
        }

        // Combine old + new items (merged by unique key)
        let updatedItemList = [...itemRowData, ...Array.from(updatedItemMap.values())];

        // Assign keyId
        updatedItemList = updatedItemList.map((item, index) => ({
            ...item,
            keyId: index + 1
        }));

        this.setState({ itemRowData: updatedItemList, open: false }, () => {
            this.finalCalculation();
        });
    };

    handleOnClick = () => {
        this.setOpenModel2();
    }

    setOpenModel2 = () => {
        this.setState({ isSelectItemPopUp: !this.state.isSelectItemPopUp });
    };

    handleDropdownCellClick = (event) => {
        let data = this.state.productObject;
        data.idItem = event.data.idItem;
        data.itemIdLabel = event.data.itemName;
        this.setState({ productObject: data, isSelectItemPopUp: !this.state.isSelectItemPopUp }, () => {
            this.getMasterItemSelectbyIDVendorwiseRate()
        });
    };


    generatePurchaseOrderInvoice = (type) => {
        if (this.state.purchaseObject.idPurchaseOrder > 0) {
            let request = [this.state.purchaseObject.idPurchaseOrder, type];
            this.transactionStockServices.downloadPurchaseInvoice(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    generatePendingPurchaseOrderInvoice = (type) => {
        if (this.state.purchaseObject.idPurchaseOrder > 0) {
            let request = [this.state.purchaseObject.idPurchaseOrder, type];
            this.transactionStockServices.generatePendingPurchaseOrderInvoice(request).then((response) => {
                if (response.status == 200 && response !== null) {
                    var file = new Blob([response.data], { type: "application/pdf" });

                    var fileURL = URL.createObjectURL(file);

                    window.open(fileURL, "_blank");

                    this.setState({
                        isModalOpen: false
                    });
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }
    }

    getFiles = (type, Filepath) => {
        if (Filepath) {
            let request = [
                // this.state.SLOTSApplicationDetails.slotsMemberId,
                type,
                Filepath,
            ];
            this.commonServices.getFiles(request).then((response) => {
                if (response.data !== null && response.status === 200) {
                    var formattedDate = moment(new Date()).format("DDMMYYYYHHmmss");
                    var filename = "";
                    filename = `${type}${formattedDate}`;
                    const extension = Filepath.split(".").pop();
                    if (extension) {
                        saveAs(new Blob([response.data]), `${filename}.${extension}`);
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("No data found");
        }
    };

    shareOnWhatsApp = () => {
        if (this.state.purchaseObject.idPurchaseOrder > 0) {
            let request = [
                this.state.purchaseObject.idPurchaseOrder,
                "PurchaseOrderInvoices"
            ];
            this.transactionStockServices.shareOnWhatsApp(request).then((response) => {
                if (response.statusCode == 200 && response !== null) {
                    if (response.responseItem.responseContent) {
                        const link = response.responseItem.responseContent;
                        const phoneNumber = this.state.purchaseObject.contactNo || "";
                        const message = `Dear Customer ${this.state.purchaseObject.contactPerson || ""},  
-> Please find attached your Purchase Order.  
-> You can view or download it using the link below:    
-> ${link}  

Thank you for your business!`;
                        const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
                        window.open(whatsappLink, "_blank");
                    } else {
                        this.SwalServices.Error("No data found");
                    }
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        }

    };

    sendOnEmail = () => {
        if (this.state.purchaseObject.idPurchaseOrder && this.state.purchaseObject.email) {
            let request = [
                this.state.purchaseObject.email,
                this.state.purchaseObject.idPurchaseOrder,
                this.state.companyName,
                "PurchaseOrderInvoices"
                //"InvoiceTempletes\\PurchaseOrderInvoices"
            ];
            this.transactionStockServices.sendPurchaseInvoiceMail(request).then((response) => {
                if (response.responseItem !== null && response.statusCode === 200) {
                    this.SwalServices.Success("Invoice snet sucessfully.");
                } else {
                    this.SwalServices.Error(response.message);
                }
            });
        } else {
            this.SwalServices.Error("No data found");
        }
    };

    render() {
        return (
            <>
                <div className='manual-invoice'>
                    <div className='data-display'>
                        <div className='data-display-inner relative'>
                            <ButtonGrp buttons={['add', 'print']}
                                onClickHandlers={{
                                    add: () => this.openPopUpForAddingItem(),
                                    // update: () => this.openPopUpForUpdateItem(),
                                    print: this.handlePrint,
                                }}
                            />
                            <PurchaseOrderPopup
                                isModalOpen={this.state.isModalOpen}
                                setOpenModel={this.setOpenModel.bind(this)}
                                purchaseObject={this.state.purchaseObject}
                                productObject={this.state.productObject}
                                handleChangeForWork={this.handleChangeForWork.bind(this)}
                                handleChangeForPayment={this.handleChangeForPayment.bind(this)}
                                handleChange={this.handleChange.bind(this)}
                                onGridReady={this.onGridReady.bind(this)}
                                close={this.closePopup.bind(this)}
                                open={this.state.open}
                                addPI={this.addPI.bind(this)}
                                addProduct={this.addProduct.bind(this)}
                                back={this.back.bind(this)}
                                submit={this.submit.bind(this)}
                                isSaving={this.state.isSaving}
                                validState={this.state.validState}
                                itemRowData={this.state.itemRowData}
                                itemColdefs={this.state.itemColdefs}
                                firstPIList={this.state.firstPIList}
                                secondPIList={this.state.secondPIList}
                                thirdPIList={this.state.thirdPIList}
                                handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                                handleChangeForDropdownForProductObject={this.handleChangeForDropdownForProductObject.bind(this)}
                                insertItem={this.insertItem.bind(this)}
                                clear={this.resetProductObject.bind(this)}
                                onItemRowDataClicked={this.onItemRowDataClicked.bind(this)}
                                delete={this.deleteItem.bind(this)}
                                handleCellClickfirstPIList={this.handleCellClickfirstPIList.bind(this)}
                                handleCellClickSecondPIList={this.handleCellClickSecondPIList.bind(this)}
                                onSelectionChanged={this.onSelectionChanged.bind(this)}
                                handleOnClick={this.handleOnClick.bind(this)}
                                generatePurchaseOrderInvoice={this.generatePurchaseOrderInvoice.bind(this)}
                                generatePendingPurchaseOrderInvoice={this.generatePendingPurchaseOrderInvoice.bind(this)}
                                pdfLink={this.state.pdfLink}
                                getFiles={this.getFiles.bind(this)}
                                sendOnEmail={this.sendOnEmail.bind(this)}
                                shareOnWhatsApp={this.shareOnWhatsApp.bind(this)}
                                usp_Users={this.state.usp_Users}
                                globalUserID={this.state.globalUserID}
                            //handleCellClickThirdPIList={this.handleCellClickThirdPIList.bind(this)}
                            />
                            <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                    <div className="table-inner">
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Purchase order</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.rowData}
                                        rowHeight={this.state.rowHeight}
                                        columnDefs={this.state.colDefs}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onRowDoubleClicked={this.onRowDoubleClicked}
                                        onGridReady={this.onGridReady}
                                        overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                        overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                        onCellClicked={this.handleCellClick}
                                    />
                                </div>
                            </div>

                            <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                                <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                    <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                        <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                    </div>
                                    <AgGridReact
                                        rowData={this.state.table2Data}
                                        columnDefs={this.state.table2ColDefs}
                                        rowHeight={this.state.rowHeight}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SelectItemListPopUp
                    modalName={"Select Item"}
                    selectItemList={this.state.productObject.itemList}
                    // paymentModeList={this.state.paymentModeList}
                    colDefs={this.state.selectItemColDefs}
                    isModalOpen={this.state.isSelectItemPopUp}
                    setOpenModel={this.setOpenModel2.bind(this)}
                    //handleChange={this.handleChange.bind(this)}
                    handleSelectChange={this.handleDropdownCellClick}
                //receiptDetails={this.state.receiptDetails}handleSelectChange
                />
            </>
        )
    }
}
